enum ActionType {
    RECEIVE_DATA = '[CORE/NETWORK_ANOMALY_MATRIX] RECEIVE_DATA',
    REQUEST_DATA = '[CORE/NETWORK_ANOMALY_MATRIX] REQUEST_DATA',
    DATA_REQUEST_ERROR = '[CORE/NETWORK_ANOMALY_MATRIX] DATA_REQUEST_ERROR',
}

export default ActionType
